class Showcase < ApplicationRecord
  belongs_to :location
end
